import router from '@/router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from './utils/token'
import { getUserId } from '@/utils/userId'
import { Message } from 'element-ui'

NProgress.configure({
  showSpinner: false
})

// 白名单
const whiteList = ['/', '/introduction', '/dynamic', '/scoreQuery', '/certificateQuery', '/password', '/personal', '/contact', '/scoreQueryMove']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  if (!store.state.user.competId) {
    store.dispatch('GetCompetId')
  }
  if (getToken()) {
    if (getUserId() && !store.state.user.userInfo.id) {
      store.dispatch('GetInfo').then(() => {
      }).catch(err => {
        store.dispatch('userLogout').then(() => {
          Message.error(err)
          next({ path: '/' })
        })
      })
    } else {
      next()
    }
    next()
  } else {
    // 没有token
    // 在免登录白名单，直接进入
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      Message({ message: '请先登录再完成报名！', type: 'warning', duration: 2000 })
      next(`/`)
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})


// WEBPACK FOOTER //
// ./src/permission.js